import coreI18n from 'answers-core/src/i18n';

import translationsEn from './locales/en/translations.json';

coreI18n.addResourceBundle('en', 'translations', translationsEn);

export default coreI18n;
